import React, { useState, useEffect } from "react"

import Sidebar from "./Sidebar"

const Component = ({ microcopy }) => {
  const [state, setState] = useState({
    reactive: false,
    visible: false,
  })

  // Generic function for appending the state
  const updateState = (newValues) => {
    setState((s) => ({ ...s, ...newValues }))
  }

  // On load, set enable the sidebar
  useEffect(() => updateState({ reactive: true }), [])

  // Toggle the sidebar visibility
  const toggleSidebar = () => updateState({ visible: !state.visible })

  // Hide the sidebar with a small delay
  const hideSidebar = () => {
    setTimeout(() => updateState({ visible: false }), 100)
  }

  return (
    <Sidebar
      microcopy={microcopy}
      state={state}
      toggleSidebar={toggleSidebar}
      hideSidebar={hideSidebar}
    />
  )
}

export default Component
